import React from 'react';
import { Chip, ChipProps } from '@material-ui/core';

type CardChipProps = ChipProps;

/**
 * A styled chip for cards, accepts all ChipProps. Providing sx values will override existing styles.
 */
const CardChip: React.FC<CardChipProps> = ({ sx, ...rest }: CardChipProps) => {
  const styles: ChipProps['sx'] = {
    borderRadius: '4px',
    paddingY: 1,
    paddingX: 0.5,
    backgroundColor: 'background.default',
    typography: 'subtitle1',
    ...sx,
  };
  return <Chip sx={styles} {...rest} />;
};

export default CardChip;
